/**
 * JaaS customer statuses which represent their account state.
 */
export const STATUSES = {
    ACTIVE: 'ACTIVE',
    BLOCKED: 'BLOCKED'
};

/**
 * Service features for JaaS users.
 */
export const FEATURES = {
    INBOUND_CALL: 'inbound-call',
    OUTBOUND_CALL: 'outbound-call',
    RECORDING: 'recording',
    SIP_INBOUND_CALL: 'sip-inbound-call',
    SIP_OUTBOUND_CALL: 'sip-outbound-call',
    STREAMING: 'streaming',
    TRANSCRIPTION: 'transcription'
};

/**
 * URL for displaying JaaS upgrade options.
 */
export const JAAS_UPGRADE_URL = 'https://jaas.8x8.vc/#/plan/upgrade';

/**
 * The prefix for the vpaas tenant.
 */
export const VPAAS_TENANT_PREFIX = 'vpaas-magic-cookie-';
